<template>
  <transition name="dialog-fade">
    <div v-if="dialog.open" class="dialog-backdrop" @click.self="onBackdropClick" role="presentation">
      <div class="dialog-panel" :class="`tone-${dialog.tone}`" role="dialog" aria-modal="true" :aria-label="dialog.title">
        <div class="dialog-header">
          <h3>{{ dialog.title }}</h3>
        </div>
        <div class="dialog-content">
          <p>{{ dialog.message }}</p>
        </div>
        <div class="dialog-actions">
          <button v-if="dialog.showCancel" class="button outline" type="button" @click="onCancel">
            {{ dialog.cancelText }}
          </button>
          <button class="button" :class="confirmButtonClass" type="button" @click="onConfirm">
            {{ dialog.confirmText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DialogService from '@/services/DialogService';

export default {
  name: 'DialogHost',
  computed: {
    dialog() {
      return DialogService.state;
    },
    confirmButtonClass() {
      if (this.dialog.tone === 'danger') {
        return 'danger';
      }
      if (this.dialog.tone === 'success') {
        return 'success';
      }
      return 'primary';
    },
  },
  methods: {
    onConfirm() {
      DialogService.close(true);
    },
    onCancel() {
      DialogService.close(false);
    },
    onBackdropClick() {
      if (this.dialog.closeOnBackdrop) {
        DialogService.close(false);
      }
    },
    onEscape(event) {
      if (event.key === 'Escape' && this.dialog.open) {
        DialogService.close(false);
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.onEscape);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onEscape);
  },
};
</script>

<style scoped lang="scss">
.dialog-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 25, 55, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 2000;
}

.dialog-panel {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border: 1px solid #d9e2ec;
  border-top-width: 5px;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.16);
}

.dialog-header {
  padding: 16px 20px 10px;

  h3 {
    margin: 0;
    color: #1f2937;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
  }
}

.dialog-content {
  padding: 0 20px 10px;

  p {
    margin: 0;
    color: #4b5563;
    line-height: 1.5;
    white-space: pre-line;
  }
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px 20px;
}

.tone-info {
  border-top-color: #0055a5;
}

.tone-warning {
  border-top-color: #f59e0b;
}

.tone-success {
  border-top-color: #22c55e;
}

.tone-danger {
  border-top-color: #ef4444;
}

.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 140ms ease;
}

.dialog-fade-enter-active .dialog-panel,
.dialog-fade-leave-active .dialog-panel {
  transition: transform 140ms ease, opacity 140ms ease;
}

.dialog-fade-enter,
.dialog-fade-leave-to {
  opacity: 0;
}

.dialog-fade-enter .dialog-panel,
.dialog-fade-leave-to .dialog-panel {
  transform: scale(0.98);
  opacity: 0;
}
</style>
